import { render, staticRenderFns } from "./SkBuscador.vue?vue&type=template&id=cefda824&scoped=true&"
import script from "./SkBuscador.vue?vue&type=script&lang=js&"
export * from "./SkBuscador.vue?vue&type=script&lang=js&"
import style0 from "./SkBuscador.vue?vue&type=style&index=0&id=cefda824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefda824",
  null
  
)

export default component.exports